import { Owners } from "models/applicationUsers";
import { PageRequest } from "models/common";
import React from "react";
import { pageRequestForPost } from "util/helpers";
import { useAuthenticatedRequestCreator } from "./useRequests";

interface BulkUpdateFields {
    owners: Owners
}

export interface BulkUpdateResult {
    updateCount: number;
}

const useUpdateSelected = () => {
    const updateSelected = useAuthenticatedRequestCreator<
        BulkUpdateResult,
        BulkUpdateFields & { cardIds: React.Key[] }
    >(data => ({
        method: "post",
        url: "/cards/bulk-update/selection",
        data: {
            cardIds: data.cardIds,
            newCustomerIds: data.owners.customers.map(c => c!.id),
            accountIds: data.owners.silentUsers.map(u => u!.accountId)
        }
    }));

    return updateSelected;
};

const useUpdateFiltered = () => {
    const updateFiltered = useAuthenticatedRequestCreator<
        BulkUpdateResult,
        BulkUpdateFields & { pageRequest: PageRequest }
    >(data => {
        const payload = {
            newCustomerIds: data.owners.customers.map(c => c!.id),
            accountIds: data.owners.silentUsers.map(u => u!.accountId),
            pageRequest: pageRequestForPost(data.pageRequest)
        };

        return {
            method: "post",
            url: "/cards/bulk-update/filter",
            data: payload
        };
    });

    return updateFiltered;
};

const useBulkCardUpdate = () => {
    const updateBySelection = useUpdateSelected();
    const updateByFilter = useUpdateFiltered();

    return { updateBySelection, updateByFilter };
};

export default useBulkCardUpdate;
